import { checkGate } from '@eventbrite/statsig';
import { CheckoutState } from '../state';

export const getGooglePayInstance = (state: CheckoutState) =>
    state.googlePay.googlePayInstance;

export const getGooglePayPaymentRequest = (state: CheckoutState) =>
    state.googlePay.googlePayPaymentRequest;

export const isGooglePayEnabled = (state: CheckoutState) =>
    !!state.googlePay.canMakePaymentsWithGooglePay &&
    isGooglePayFeatureGateEnabled();

export const hasErrorInGooglePay = (state: CheckoutState) =>
    state.googlePay.hasError;

export const isGooglePayFeatureGateEnabled = () =>
    checkGate('google_pay_eligibility_checkout');
